import React from "react";
import icons from "../../icons.config";

const SortDropdown = ({
  isDropdownOpen,
  setIsDropdownOpen,
  selectedSort,
  handleSortOptionClick,
  sortOptions, // Receive sortOptions from Shop
}) => (
  <div
    className={`hidden lg:flex relative 
      ${isDropdownOpen ? "bottom-28" : "bottom-28"} 
      xl:left-[38%] left-[35%] items-center`}
  >
    <h2 className="font-outfit font-light text-2xl">{selectedSort || "Sort By"}</h2>
    <img
      src={icons.Expand_down}
      alt="down arrow"
      className={`mr-2 cursor-pointer ${isDropdownOpen ? "bottom-28" : "bottom-28"}`}
      onClick={() => setIsDropdownOpen((prev) => !prev)}
    />
    {isDropdownOpen && (
      <div
        className="absolute top-full bg-tertiary right-2 rounded-md p-2 z-40"
        style={{ height: "150px", width: "250px" }} // Adjusted height for fewer options
      >
        {sortOptions.map((option) => (
          <div
            key={option}
            className="cursor-pointer text-primary1 font-outfit font-light text-lg mt-1"
            onClick={() => handleSortOptionClick(option)}
          >
            {option}
          </div>
        ))}
      </div>
    )}
  </div>
);

export default SortDropdown;